import type { UpdateLineItemResponse, UpdateLineItemVariables } from './types';

import { ENDPOINT } from '~/constants/endpoints';

import { vestigasApi } from '~/services/kyClient';

import {
  zodUpdateLineItemPayloadSchema,
  zodUpdateLineItemResponseSchema,
} from './validations';

/**
 * Updates editable values on an invoice line item.
 *
 * @param variables - Invoice, line-item, and editable values to update.
 * @returns The updated invoice detail.
 * @see https://app.dev.vestigas.com/redoc#tag/Invoices/operation/update_line_item_invoices__invoice_id__line_items__line_item_id__patch
 */
export async function updateLineItem({
  invoiceId,
  lineItemId,
  payload,
}: UpdateLineItemVariables): Promise<UpdateLineItemResponse> {
  const response = await vestigasApi
    .patch(ENDPOINT.INVOICE.UPDATE_LINE_ITEM(invoiceId, lineItemId), {
      json: payload,
      validate: {
        body: zodUpdateLineItemPayloadSchema,
        response: zodUpdateLineItemResponseSchema,
      },
    })
    .json<UpdateLineItemResponse>();

  return response;
}
